import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {complianceKpiSummaryUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {ComplianceKpiSummary} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * The Compliance tab's KPI strip (`GET supplier_360/compliance_requirement/kpi_summary/?entity=`).
 * A plain aggregate, not a paginated list — the response is the object itself.
 */
export function useComplianceKpiSummaryQuery(entityId: number | undefined) {
    const url = complianceKpiSummaryUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<ComplianceKpiSummary>(url)).data,
        enabled: Boolean(entityId),
    });
}
